import React from "react";
import { QuoteExpando } from "../..";
import "./Accordion.scss";

export interface IAccordionItem<T> {
  title: string;
  content: (props: T | undefined) => React.ReactNode;
}

export interface IAccordionProps<T> {
  heading?: string;
  items: IAccordionItem<T>[];
  renderData?: T;
}

/**
 * Accordion component built with `QuoteExpando`.
 * 
 * @status stable
 */
export function Accordion<T>({ heading, items, renderData }: IAccordionProps<T>) {
  return (
    <div className="accordion">
      <div className="accordion__inner">
        {heading && <h2>{heading}</h2>}
        {items.map(({ title, content }) => (
          <QuoteExpando key={title} question={title}>
            {content(renderData)}
          </QuoteExpando>
        ))}
      </div>
    </div>
  );
};
